import { render } from "./Button.vue?vue&type=template&id=92cd8aa4&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=92cd8aa4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-92cd8aa4"

export default script